import { render } from "./ChangePinSection.vue?vue&type=template&id=2db36e7e&scoped=true"
import script from "./ChangePinSection.vue?vue&type=script&lang=js"
export * from "./ChangePinSection.vue?vue&type=script&lang=js"

import "./ChangePinSection.vue?vue&type=style&index=0&id=2db36e7e&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/ru/components/user-settings-view/change-pin-section.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fuser-settings-view%2FChangePinSection.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/components/user-settings-view/change-pin-section.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fuser-settings-view%2FChangePinSection.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db36e7e"]])

export default __exports__